import gql from 'graphql-tag'

import { listProducts } from '../fragments'

export default gql`
query listProducts($filter: ProductFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listProducts(filter: $filter, params: $params) {
			...listProducts
		}
	}
}
${listProducts}`
